import { reducer as divisionsReducer } from './model/index';
export default divisionsReducer;
